__turbopack_context__.v({
  "accessibilityStatementBanner": "PlasmicAccessibilityStatement-module___0dGhW__accessibilityStatementBanner",
  "calloutSection": "PlasmicAccessibilityStatement-module___0dGhW__calloutSection",
  "contactModal": "PlasmicAccessibilityStatement-module___0dGhW__contactModal",
  "footer": "PlasmicAccessibilityStatement-module___0dGhW__footer",
  "header": "PlasmicAccessibilityStatement-module___0dGhW__header",
  "root": "PlasmicAccessibilityStatement-module___0dGhW__root",
});
